export enum ContentProblem {
  EXPIRED = "expired",
  FAKE = "fake",
  INACCURATE = "inaccurate",
  OFFENSIVE = "offensive",
  ADVERTISEMENT = "advertisement",
  TECHNICAL_ISSUE = "technical_issue",
  NOT_HIRING = "not_hiring",
  PHOTO = "photo",
  OTHER = "other",
}

/** Max length for report-job free-text feedback (ViewJob + job-card). */
export const REPORT_JOB_FEEDBACK_MAX_LENGTH = 300;
